<template>
  <div class="pricing container">
    <section>
      <div class="container">
        <div class="blob-1">
          <svg
            viewBox="0 0 200 200"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill="rgba(0,0,0,0.02)"
              d="M49.2,-35.2C57.6,-28.7,53.9,-8.6,50.1,12.9C46.4,34.4,42.5,57.3,31.5,60.8C20.6,64.3,2.5,48.3,-18.8,38.3C-40.1,28.3,-64.7,24.4,-69.3,13.2C-73.9,2.1,-58.6,-16.2,-43.7,-24.2C-28.8,-32.1,-14.4,-29.8,3,-32.2C20.4,-34.6,40.8,-41.7,49.2,-35.2Z"
              transform="translate(100 100)"
            />
          </svg>
        </div>
        <div class="blob-2">
          <svg
            viewBox="0 0 200 200"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill="rgba(0,0,0,0.02)"
              d="M51.6,-55.9C65.1,-50.1,73.2,-32.2,69.2,-17.7C65.2,-3.2,49.2,8,40.2,22.9C31.2,37.8,29.3,56.5,19.9,63.8C10.6,71.1,-6.2,67,-22.8,61.5C-39.5,55.9,-56,48.9,-57.1,37.5C-58.1,26.2,-43.7,10.5,-41.4,-8.1C-39.1,-26.8,-48.9,-48.3,-44,-55.6C-39.1,-62.9,-19.6,-56,-0.3,-55.6C19,-55.3,38.1,-61.7,51.6,-55.9Z"
              transform="translate(100 100)"
            />
          </svg>
        </div>
        <div class="row hero">
          <div class="col-12">
            <div class="text-center">
              <h1>Pricing</h1>
              <p>
                Virginia is completely free. Sign up today and let Virginia screen sales
                solicitations, prioritize your team’s criteria needs, and identify best fits.
              </p>
              <div class="cta-box">
                <h6>Get started in minutes</h6>
                <router-link
                  to="/register"
                  tag="button"
                  class="btn btn-primary btn-lg"
                >
                  Sign Up Today
                </router-link>
                <div class="text-box">
                  Registration is Free!
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 hero-screenshot">
            <img
              src="@/assets/img/hero-screenshot.png"
              alt="Virginia Screenshot"
              class="img-fluid"
            >
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

export default {
  name: 'Pricing',
};
</script>

<style lang="scss" scoped>
.pricing {
  .hero {
    max-width: 690px;
    margin: 0 auto;
    padding-top: 30px;

    @media (max-width: $sm-max) {
      padding-top: 30px;
      padding-bottom: 45px;
    }

    h1 {
      margin-bottom: 8px;
      color: #353e44;
      font-size: 64px;
      line-height: 72px;
      font-weight: 800;

      @media (max-width: $sm-max) {
        font-size: 54px;
        line-height: 1.2;
      }
    }

    p {
      color: #4f5c65;
      font-size: 20px;
      font-weight: 400;
    }

    .btn-lg {
      height: 60px;
      padding-left: 45px;
      padding-right: 45px;
      background: $blue;
      border-color: $blue;
      transform: scale(1);
      transition: all 150ms ease;
      width: auto !important;
      margin: 0 auto;

      &:hover {
        background: darken($blue, 5%);
        border-color: darken($blue, 5%);
        transform: scale(1.05);
      }
    }

    .text-box {
      color: rgba(black, 0.3);
      font-size: 14px;
      font-weight: 700;
      margin-top: 14px;
    }

    .cta-box {
      margin-top: 30px;

      h6 {
        color: #4f5c65;
        font-size: 16px;
        margin-top: 0;
        margin-bottom: 12px;
        line-height: 24px;
        font-weight: 700;
      }
    }
  }

  .blob-1 {
    position: absolute;
    height: 1000px;
    width: 1000px;
    top: -500px;
    right: -450px;
  }

  .blob-2 {
    position: absolute;
    height: 1000px;
    width: 1000px;
    top: -100px;
    left: -600px;

    @media (max-width: $sm-max) {
      display: none;
    }
  }

  .marketing-heading {
    text-align: center;
  }

  .marketing-heading label {
    font-style: normal;
    font-weight: normal;
    font-size: 17px;
    text-align: center;
    letter-spacing: 0.1em;
    margin-bottom: 0;
    color: $blue;
    text-transform: uppercase;
  }

  .marketing-heading h3 {
    font-style: normal;
    font-weight: bold;
    font-size: 38px;
    color: #fff !important;
    margin-top: 15px;
    margin-bottom: 35px;
    line-height: 45px;
  }

  .marketing-heading p {
    margin: 0 auto;
    padding: 0;
    margin-bottom: 45px;
    font-size: 17px;
    max-width: 450px;
    color: rgba(255, 255, 255, 0.67);
  }
}
</style>
